import React, { useState } from "react";
import moment from "moment-timezone"
import "../../shared/styles/shared-styles.css";
import "./end-assignment-modal.css";
import ReasonCodes from "../reason-codes/ReasonCodes";

const EndAssignmentModal = (props) => {
  const {
    dropdownOptions,
    onClose,
    onEndAssignment,
    timezone,
    user,
    userJobs,
  } = props;
  const [reasonCode, setReasonCode] = useState(null);
  const [otherRCInputVisible, setOtherRCInputVisible] = useState(false);
  const [otherReasonCode, setOtherReasonCode] = useState("");
  const [reasonCodeEmpty, setReasonCodeEmpty] = useState(false);
  const [selectedJob, setSelectedJob] = useState(userJobs[0]);

  const onChangeJob = e => {
    const { value } = e.target;
    const newSelectedJob = userJobs.find(job => job.jobId === +value);
    setSelectedJob(newSelectedJob);
  };

  const onConfirmEnd = () => {
    // If reason code is not selected
    // or other reason code input is empty, show error message
    if ((reasonCode === null) || (otherRCInputVisible && !otherReasonCode)) {
      return setReasonCodeEmpty(true);
    }
    onEndAssignment({ reasonCode, otherReasonCode, job: selectedJob });
  };

  const getJobDate = job => {
    const shiftStartDate = moment(job.start_date_time).tz(timezone).format('MMM D');
    const shiftEndDate = moment(job.end_date_time).tz(timezone).format('MMM D');
    const formattedShiftDate = `${shiftStartDate} - ${shiftEndDate}`;
    const shiftStartTime = moment(job.start_date_time).tz(timezone).format('h:mm a');
    const shiftEndTime = moment(job.end_date_time).tz(timezone).format('h:mm a');
    const formattedShiftTime = `${shiftStartTime} – ${shiftEndTime}`;
    return `${formattedShiftDate}, ${formattedShiftTime}`;
  };

  return (
    <div className="shift-modal-container">
      <div className="modal-body end-assignment-modal-body">
        <img src="images/roster/edit-shift-error.svg" />
        <span className="modal-body-header">Cancel all remaining shifts for this assignment?</span>
        <span className="modal-body-description">
          This will end the assignment for {user.fullname} following today’s shift.
        </span>
        <div className="request-container">
          <span className="select-title">
            Select Job Request
          </span>
          <select
            className="edit-assignments-select"
            name="selected-request"
            onChange={onChangeJob}
            required
          >
            {
              userJobs.map(job => {
                const date = getJobDate(job);
                return (
                  <option value={job.jobId} key={job.jobId}>
                    Request {job.jobId} ({date})
                  </option>
                );
              })
            }
          </select>
        </div>
        <ReasonCodes
          boldTitle={true}
          dropdownOptions={dropdownOptions}
          otherRCInputVisible={otherRCInputVisible}
          otherReasonCode={otherReasonCode}
          reasonCodeEmpty={reasonCodeEmpty}
          setOtherRCInputVisible={setOtherRCInputVisible}
          setOtherReasonCode={setOtherReasonCode}
          setReasonCode={setReasonCode}
          setReasonCodeEmpty={setReasonCodeEmpty}
          title="Reason for cancelling"
        />
        <div className="modal-buttons-container">
          <button
            data-testid="on-close-cancel-modal"
            className="modal-button modal-cancel-button"
            onClick={onClose}
            data-pendo-key="roster-week-view-cancel-modal-no-goback-button"
          >
            No, go back
          </button>
          <button
            data-testid="on-confirm-cancel"
            className={reasonCode === null ? "button-disabled" : "modal-button modal-confirm-button"}
            onClick={onConfirmEnd}
            disabled={reasonCode === null}
            data-pendo-key="roster-week-view-cancel-modal-yes-cancel-button"
          >
            Yes, cancel this assignment
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndAssignmentModal;
